var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Compressor from 'compressorjs';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
export const getCompressedImage = (image, compressionAmount = 0.8) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        new Compressor(image, {
            minHeight: 0,
            minWidth: 0,
            maxHeight: 400,
            maxWidth: Infinity,
            mimeType: 'auto',
            checkOrientation: true,
            quality: compressionAmount,
            convertSize: 500000,
            success: (compressedResult) => {
                resolve(compressedResult);
            },
        });
    });
});
export const captureAndDownloadComponent = (element, fileName) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const canvas = yield html2canvas(element);
        canvas.toBlob((blob) => {
            if (blob) {
                saveAs(blob, `${fileName !== null && fileName !== void 0 ? fileName : 'image'}.png`);
            }
        });
    }
    catch (error) {
        console.error('Failed to capture component:', error);
    }
});
//# sourceMappingURL=image.js.map